import React, { useCallback, useEffect, useState, FC } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import moment from 'moment';

//Components
import ActivityModal from '../common/ActivityModal';
import ActivityTable from '../common/ActivityTable';
import ActivityToast from '../common/ActivityToast';
import ActivityLoading from '../common/ActivityLoading';

//Services
import { getGroups } from '../../services/GroupService';
import { removeGroup } from '../../services/NewGroupService';

//Types
import { GroupInterface, ModalOptionsInterface, TableColumnInterface, TableOptionsInterface, ToastOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

//Icons
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

const systemGroups: Array<string> = ["users_admin", "users_students", "users_teacher"];

const UserGroupList: FC = () => {
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: "", buttons: [] });
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });
    const [loading, setLoading] = useState(false);
    const [userGroups, setUserGroups] = useState<Array<GroupInterface>>([]);

    const history = useHistory();

    const fetchGroups = useCallback(() => {
        getGroups().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
            setUserGroups(response as Array<GroupInterface>);
            setLoading(false);
        })
    }, [])

    useEffect(() => {
        setLoading(true);
        fetchGroups();
    }, [fetchGroups])

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Grupo", value: "name" },
        {
            title: "Fecha de inicio",
            value: "start_date",
            render: (data: GroupInterface) => data.start_date ?
                <div className="container-center">{moment(data.start_date.toDate()).format("DD-MM-YYYY")}</div> : ""
        },
        {
            title: "Fecha de fin",
            value: "end_date",
            render: (data: GroupInterface) => data.end_date ?
                <div className="container-center">{moment(data.end_date.toDate()).format("DD-MM-YYYY")}</div> : ""
        },
        {
            value: "edit",
            render: (data: GroupInterface) =>
                < div className="buttons-container-center" >
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => goToUpdateGroup(data)}>
                        <FaPencilAlt />
                    </Button>
                    {!systemGroups.includes(data.name) && <Button size="sm" style={{ margin: '5px' }} onClick={() => handleDisableGroup(data)}>
                        <FaTrash />
                    </Button>}
                </div >
        }
    ]

    const goToUpdateGroup = (group: GroupInterface) => {
        history.push({ pathname: `/userGroup/edit/${group.id}` });
    }

    const handleDisableGroup = (group: GroupInterface) => {
        setModal({
            open: true,
            header: "Borrar",
            body: "Estas seguro de que quieres borrar este grupo?",
            buttons: [
                { text: "Borrar", func: () => disableGroup(group) },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const disableGroup = (group: GroupInterface) => {
        setLoading(true);

        if (group && group.id) {
            removeGroup(group.id).then(() => {
                handleModalClose();
                fetchGroups();
            })
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const handleToastClose = (data: any) => {
        setToastOptions({ open: false, message: "" });
    }

    const tableOptions: TableOptionsInterface = {
        height: 700
    }

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <ActivityToast {...toastOptions} onClose={handleToastClose} autohide={4000} />
            <ActivityModal {...modal} onClose={handleModalClose} />
            <div style={{ marginBottom: '10px' }}>
                <h1>Grupos de usuarios</h1>
            </div>
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.push('/userGroup/new')}>Agregar grupo</Button>
                <Button variant="outline-primary" onClick={() => history.push('/users/importUsers')} style={{ marginLeft: '10px' }}>Importar usuarios</Button>
            </div>
            <ActivityTable data={userGroups ? userGroups : []} columns={tableColumns} options={tableOptions} />
        </Container>
    )
}

export default UserGroupList;
